import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DnaProfile } from '../models/dna-profile.model';
import { DnaJobApplication } from '../models/dna-job-application.model';

@Injectable({ providedIn: 'root' })
export class DnaProfileMockService {
  getProfile(): Observable<DnaProfile> {
    return of({
      candidateName: 'James',
      customerName: 'Foundation Medicine',
      customerLogoUrl: 'assets/images/dna-customer-logo-placeholder.png',
      avatarInitials: 'JO',
      avatarColor: '#007ebb',
    });
  }

  getApplications(): Observable<DnaJobApplication[]> {
    return of([
      {
        jobTitle: 'Field Service Technician',
        appliedDate: '2026-09-04',
        status: 'Submitted',
      },
      {
        jobTitle: 'Quality Assurance Inspector',
        appliedDate: '2026-09-12',
        status: 'Not selected',
      },
      {
        jobTitle: 'Production Supervisor',
        appliedDate: '2026-09-19',
        status: 'Not selected',
        rejectionReason: 'Requirement not met: 3 years of CNC experience',
      },
      {
        jobTitle: 'Manufacturing Engineer',
        appliedDate: '2026-10-02',
        status: 'Interview scheduled',
      },
      {
        jobTitle: 'CNC Machinist II',
        appliedDate: '2026-10-08',
        status: 'In review',
      },
      {
        jobTitle:
          'Maintenance Planner with an intentionally long job title to demonstrate wrapping',
        appliedDate: '2026-08-28',
        status: 'In review',
      },
    ]);
  }
}
